import { render, staticRenderFns } from "./model1.vue?vue&type=template&id=0f99dfc8&scoped=true"
import script from "./model1.vue?vue&type=script&lang=js"
export * from "./model1.vue?vue&type=script&lang=js"
import style0 from "./model1.vue?vue&type=style&index=0&id=0f99dfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f99dfc8",
  null
  
)

export default component.exports